class BrandsWeLove extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.classList.contains('loaded')) return;
    this.classList.add('loaded');

    new Swiper(this.querySelector('.brands-we-love-swiper'), {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        640: {
          slidesPerView: 2.2,
        },
        990: {
          slidesPerView: 4,
        },
        1440: {
          slidesPerView: 5,
        },
      },
    });
  }
}

customElements.define('brands-we-love', BrandsWeLove);
